var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
import { JackpotWinningAnimation } from "../../../data";
import { observable, action } from "mobx";
export class JackpotWinningAnimationState {
    constructor(cms, dict, store) {
        this.cms = cms;
        this.dict = dict;
        this.store = store;
        this.jackpotWinAnimation = new JackpotWinningAnimation(cms);
    }
    subscribe() {
        this.store.addJackpotWinAnimationItem(this.jackpotWinAnimation);
    }
    setWinning(flag) {
        if (this.jackpotWinAnimation.WonJackpot) {
            this.jackpotWinAnimation.WonJackpot.isWon = flag;
        }
    }
    get currencySymbol() {
        if (this.jackpotWinAnimation.WonJackpot) {
            return this.store.getCurrencySymbol(this.jackpotWinAnimation.WonJackpot.jackpotWinData.jackpot.currencyId);
        }
        return "";
    }
}
__decorate([
    observable,
    __metadata("design:type", JackpotWinningAnimation)
], JackpotWinningAnimationState.prototype, "jackpotWinAnimation", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], JackpotWinningAnimationState.prototype, "setWinning", null);
//# sourceMappingURL=JackpotWinningAnimationState.js.map